const routes = {
  main: '/',
  // The proposed dashboard, beside the current one until it is signed off.
  overview: '/overview',
  role: '/role',
  studies: 'studies',
  admin: '/admin',
  authentication: {
    index: '/auth',
    phoneRegister: 'phone-register',
    login: 'login',
    loginOtpVerification: 'login-otp-verification',
    signup: 'signup',
    phoneOtp: 'phone-verification',
    userDetails: 'user-details',
    emailOtp: 'email-verification',
    personalPin: 'personal-pin',
    logout: 'logout',
    resetPin: 'reset-pin',
    newPinReset: 'reset-pin/new',
  },
  campaign: {
    index: '/campaign',
    consent: 'consent',
    optOut: 'opt-out',
  },
  processedEvents: {
    index: '/processed-events',
  },
  listOne: {
    index: '/list-one',
    statuses: 'statuses',
  },
  listTwo: {
    index: '/list-two',
  },
  listThree: {
    index: '/list-three',
  },
  listFour: {
    index: '/list-four',
  },
  listFive: {
    index: '/list-five',
    needApproval: 'need-approval',
    otherInvoices: 'other-invoices',
  },
  listSix: {
    index: '/list-six',
  },
  listZero: {
    index: '/list-zero',
    participants: 'participants',
  },
  cargoClaims: {
    index: '/cargo-claims',
    details: ':reference',
  },
  healthClaims: {
    index: '/health-claims',
    dashboard: 'dashboard',
    closedTickets: 'closed-tickets',
    // The Closed Tickets page's old address, kept so bookmarks still land.
    directClaims: 'direct-claims',
    reimbursementApproval: 'reimbursement-approval',
    reimbursementClaims: 'reimbursement-claims',
    reimbursementAzadea: 'azadea',
    reimbursementGlobal: 'global',
    directBilling: 'direct-billing',
  },
  docs: {
    index: '/docs',
    workflow: 'workflow',
    statuses: 'statuses',
    scenarios: 'scenarios',
    fields: 'fields',
    cargoClaims: 'cargo-claims',
    cargoStatuses: 'cargo-statuses',
    cargoFields: 'cargo-fields',
    healthClaims: 'health-claims',
  },
  logs: {
    index: '/logs',
  },
};

export default routes;
